export default __webpack_public_path__ + "static/media/interior1.20a22d9c.jpeg";